<template>
    <div>
        <GridColumnMenuCheckboxFilter :column="column" :filter="filter" :filterable="filterable" :unique-data="uniqueData"
            :search-box="false" :data-items="it" :expanded="true" @filterchange="filterChange" @expandchange="expandChange"
            @closemenu="closeMenu" />
    </div>
</template>
<script>
import { GridColumnMenuCheckboxFilter } from '@progress/kendo-vue-grid';

export default {
    props: {
        column: Object,
        filter: Object,
        filterable: Boolean,
        uniqueData: {
            type: Boolean,
            default: true
        },
        items: Array
    },
    data() {
        return {

        };
    },
    computed: {
        it() {
            return [
                {
                    companyInfoFieldEn: "Disabled",
                    companyInfoFieldTc: "已停用",
                    companyInfoFieldSc: "已停用",
                },
                {
                    companyInfoFieldEn: "Active",
                    companyInfoFieldTc: "已上架",
                    companyInfoFieldSc: "已上架",
                },
                {
                    companyInfoFieldEn: "Unsubmitted",
                    companyInfoFieldTc: "未提交",
                    companyInfoFieldSc: "未提交",
                },
            ];
        }
    },
    components: {
        'GridColumnMenuCheckboxFilter': GridColumnMenuCheckboxFilter
    },
    methods: {
        expandChange() {
            this.$emit('expandchange');
        },
        closeMenu() {
            this.$emit('closemenu');
        },
        filterChange(newDescriptor, e) {
            this.$emit('filterchange', newDescriptor, e);
        }
    }
}
</script>